import { HighContrastSelector, memoizeFunction } from '@fluentui/react';
import { baseFabricFocusSelector, commonHighContrastFocusedDisabledStyles, commonHighContrastHoverFocusStyles, commonHighContrastOutlineFocusedDisabled, commonHighContrastOutlineHoverFocus, getInnerBorderStyles, getStandardControlSemanticColorsWithTheme, } from './';
export var getCommonIsFocusVisibleStyles = memoizeFunction(function (theme) {
    var _a;
    var standardControlSemanticColors = getStandardControlSemanticColorsWithTheme(theme);
    var style = [
        {
            selectors: {
                ':after': [
                    getInnerBorderStyles({
                        width: 2,
                        color: standardControlSemanticColors.focusedBorderColor,
                        gap: -1,
                    }),
                    (_a = {}, _a[HighContrastSelector] = { border: 'none' }, _a),
                ],
            },
        },
        commonHighContrastOutlineHoverFocus,
        commonHighContrastHoverFocusStyles,
    ];
    return style;
});
export var getCommonDisabledIsFocusVisibleStyles = memoizeFunction(function (theme) {
    var _a;
    var standardControlSemanticColors = getStandardControlSemanticColorsWithTheme(theme);
    var style = [
        {
            backgroundColor: standardControlSemanticColors.disabledBackgroundColor,
            selectors: {
                ':after': [
                    getInnerBorderStyles({
                        width: 2,
                        color: standardControlSemanticColors.focusedBorderColor,
                        gap: -1,
                    }),
                    (_a = {}, _a[HighContrastSelector] = { border: 'none' }, _a),
                ],
            },
        },
        commonHighContrastOutlineFocusedDisabled,
        commonHighContrastFocusedDisabledStyles,
    ];
    return style;
});
export var getCommonActiveStyles = memoizeFunction(function (theme) {
    var standardControlSemanticColors = getStandardControlSemanticColorsWithTheme(theme);
    var style = [
        {
            backgroundColor: standardControlSemanticColors.pressedBackgroundColor,
            color: standardControlSemanticColors.textColor,
        },
        commonHighContrastOutlineHoverFocus,
        commonHighContrastHoverFocusStyles,
    ];
    return style;
});
export var commonMozFocusInnerStyles = {
    border: '0',
};
export var getButtonStateStyles = memoizeFunction(function (theme, expanded, disabled) {
    var _a, _b;
    var standardControlSemanticColors = getStandardControlSemanticColorsWithTheme(theme);
    if (expanded) {
        return {
            backgroundColor: standardControlSemanticColors.expandedBackgroundColor,
            color: standardControlSemanticColors.textColor,
            selectors: (_a = {
                    ':focus': {
                        outline: '0',
                    },
                    ':hover': {
                        backgroundColor: standardControlSemanticColors.expandedBackgroundColor,
                        color: standardControlSemanticColors.textColor,
                    }
                },
                _a[baseFabricFocusSelector + ", &:focus"] = disabled
                    ? getCommonDisabledIsFocusVisibleStyles(theme)
                    : getCommonIsFocusVisibleStyles(theme),
                _a),
        };
    }
    return {
        selectors: (_b = {
                ':hover': {
                    backgroundColor: standardControlSemanticColors.hoverBackgroundColor,
                    color: standardControlSemanticColors.textColor,
                },
                ':focus': {
                    outline: '0',
                }
            },
            _b[baseFabricFocusSelector + ", &:focus"] = disabled
                ? getCommonDisabledIsFocusVisibleStyles(theme)
                : getCommonIsFocusVisibleStyles(theme),
            _b[':active'] = getCommonActiveStyles(theme),
            _b['::-moz-focus-inner'] = commonMozFocusInnerStyles,
            _b),
    };
});
//# sourceMappingURL=getButtonStateStyles.js.map